import React, {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";
import {useFocusEffect} from "@react-navigation/native";
import {Image, View} from "react-native";
import Text from "../components/Text";
import FontAwesome from "../components/FontAwesome";
import {ColumnSpace} from "../components/_CommonComponents";
import Button from "../components/Button";
import PWAInstallPromptComponents from "../../../components/functional-components/PWAInstallPromptComponents";

export default function PWAInstallPrompt(props: { route: any, navigation: any, header: string, children: any }) {
    const configContext = useContext(AppConfigContext);
    const colors = Colors.instance(configContext.theme, configContext.color);

    let {event, origin}: { event: any, origin: "browser" | "manual" } = props.route.params;

    useFocusEffect(React.useCallback(() => {
        configContext.setPageTitle("");
        configContext.setIfPageHasHeader(false);
    }, []));

    return <View style={{
        backgroundColor: colors.get("transparentBackground") as string,
        flex: 1, alignItems: 'flex-end', justifyContent: 'flex-end', padding: 8
    }}>
        <View style={{
            width: "100%",
            backgroundColor: colors.get("primaryColor") as string,
            overflow: "hidden",
            borderRadius: 8
        }}>
            <View style={{padding: 10, flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
                <Text color="#fff" size={16}>از سفارشتون راضی بودین؟ </Text>
                <FontAwesome icon={""} size={16} color={"#fff"} type={"regular"}/>
            </View>
            <View
                style={{backgroundColor: colors.get("highConBackground") as string, padding: 14, alignItems: "center"}}>
                <PWAInstallPromptComponents event={event} origin={origin}>

                    <Text size={16} color={"#f00"} weight={600}>تحفیف ویژه برای اولین سفارش آنلاین از ما</Text>
                    <ColumnSpace/>
                    <Text size={12} color={colors.get("highConText") as string}>با زدن یک دکمه، اپلیکیشن ما رو روی گوشیتون
                        نصب کنین و از تخفیفات ویژه سفارش آنلاین ما استفاده کنین، حتی از داخل منزل!</Text>
                    <ColumnSpace/>
                    <Text role="install-text" size={14} color={colors.get("primaryColor") as string} weight={500}></Text>
                    <ColumnSpace/>
                    {/*@ts-ignore*/}
                    <Image role="aths-image" style={{
                        width: 230,
                        height: 100
                    }}/>
                    <ColumnSpace/>
                    <Button style={{alignSelf: "flex-end"}} role="understand-button" color={colors.get("primaryColor") as string} />

                </PWAInstallPromptComponents>
            </View>
        </View>

    </View>
}